import React, {
    useContext,
    useState,
    useRef,
    createContext,
    useEffect,
  } from "react";
  
  interface GeneratedImage {
    url: string;
    width: number;
    height: number;
    content_type: string;
  }
  
  interface ImageItem {
   _id?: string;
  url: string;
  [key: string]: any;
  userId: string;
  modelId: string;
  status: string;
  statusResponse?: {
    status: string;
    payload?: {
      images?: GeneratedImage[];
    };
  };
  inputData?: {
    prompt?: string;
    imageUrl?: string;
  };
}

interface ImageWebSocketContextProps {
  cartoonImageUrl: string[];
  sendMessage: (message: any) => void;
  cartoonGeneratedImage: ImageItem[];
  reconnectWebSocket: () => void;
}

const cartoonWebSocket = createContext<ImageWebSocketContextProps | undefined>(undefined);

export const CartoonImageWebSocketProvider: React.FC<{
  userId: string;
  modelId: string;
  children: React.ReactNode;
}> = ({ userId, modelId, children }) => {
  const socketRef = useRef<WebSocket | null>(null);
  const [cartoonGeneratedImage, setCartoonGeneratedImage] = useState<any[]>([]);
  const [cartoonImageUrl, setCartoonImageUrl] = useState<string[]>([]);

  const socketURL = `${process.env.REACT_APP_WEB_SOCKET_URL}image?userId=${userId}&modelId=${modelId}`;

  const connectWebSocket = React.useCallback(() => {
    if (!userId || !modelId) return;

    const socket = new WebSocket(socketURL);

    socket.onopen = () => {
      console.log("Cartoon WebSocket connected:", socket.url);
    };

    socket.onmessage = (event) => {
      console.log("WebSocket message received:", event.data);
      try {
        const parsed = JSON.parse(event.data);
        const item = parsed?.data;
        setCartoonGeneratedImage(item);
        const imageUrl = item[0]?.url || "";
        setCartoonImageUrl(imageUrl);
      } catch (err: any) {
        console.warn("WebSocket message parse error:", err);
        setCartoonGeneratedImage([]);
        setCartoonImageUrl([]);
      }
    };

    socket.onerror = (err) => {
      console.error("WebSocket error:", err);
    };

    socketRef.current = socket;
  }, [userId, modelId, socketURL]);

  const closeWebSocket = () => {
       console.log("Closing WebSocket...");
    if (socketRef.current) {
      socketRef.current.close();
      socketRef.current = null;
    }
  };

 const reconnectWebSocket = () => {
    closeWebSocket();
      console.log("Reconnecting WebSocket...");
    connectWebSocket();
  };
 useEffect(() => {
    console.log("ids", userId, modelId);
    if (!userId || !modelId) return;
    connectWebSocket();

  }, [userId, modelId, connectWebSocket]);

  const sendMessage = (message: any) => {
    if (socketRef.current?.readyState === WebSocket.OPEN) {
      socketRef.current.send(JSON.stringify(message));
    } else {
      console.warn("WebSocket not open. Message not sent:", message);
    }
  };

  return (
    <cartoonWebSocket.Provider
      value={{
        cartoonImageUrl,
        sendMessage,
        cartoonGeneratedImage,
        reconnectWebSocket, 
      }}
    >
      {children}
    </cartoonWebSocket.Provider>
  );
};

export const useImageWebSocket = () => {
  const context = useContext(cartoonWebSocket);
  if (!context) {
    throw new Error("useImageWebSocket must be used within an ImageSocketProvider");
  }
  return context;
};